import PropTypes from 'prop-types';

export const ResponsePropType = PropTypes.shape({
  data: PropTypes.any,
  status: PropTypes.number,
  message: PropTypes.string,
  success: PropTypes.bool,
});

export const ErrorPropType = PropTypes.shape({
  message: PropTypes.string,
  status: PropTypes.number,
});

export const PaginationPropType = PropTypes.shape({
  page: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
});

export const SelectOptionPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
});
